// Dui start
import { generateColorPalettesDefault, generate } from '@duxton-web/design-tokens/antd';
import { colorBackgroundDefault, colorBackgroundDisabled, colorContentDefault, colorContentDim, colorContentDisabled, colorContentSubtle, colorStatusNeutralSoft, colorStatusNeutralSoftest, colorStatusNeutralDefault, colorBrandSecondaryBold, colorBrandSecondaryBoldest, colorBrandSecondarySoftest, colorBrandSecondarySoft, colorBrandSecondaryDefault, colorBackgroundAltInverse, colorOutlineDefault } from '@duxton-web/design-tokens/themes/light';
import { getAlphaColor, getSolidColor } from './colorAlgorithm';
export const generateColorPalettes = baseColor => {
  const DuxtonColorPalettes = generateColorPalettesDefault(baseColor);
  if (DuxtonColorPalettes) {
    return DuxtonColorPalettes;
  }
  const colors = generate(baseColor);
  return {
    1: colors[0],
    2: colors[1],
    3: colors[2],
    4: colors[3],
    5: colors[4],
    6: colors[5],
    7: colors[6],
    8: colors[4],
    9: colors[5],
    10: colors[6],
    11: colors[6] // Dui
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
};
export const generateNeutralColorPalettes = (bgBaseColor, textBaseColor) => {
  const colorBgBase = bgBaseColor || colorBackgroundDefault;
  const colorTextBase = textBaseColor || colorContentDefault;
  return {
    colorBgBase,
    colorTextBase,
    colorText: colorContentDefault,
    // Dui
    colorTextSecondary: colorContentSubtle,
    // Dui
    colorTextTertiary: colorContentDim,
    // Dui
    colorTextQuaternary: colorContentDisabled,
    // Dui
    colorFill: colorStatusNeutralSoft,
    // Dui
    colorFillSecondary: colorStatusNeutralSoftest,
    // Dui
    colorFillTertiary: colorBackgroundDisabled,
    // Dui
    colorFillQuaternary: getAlphaColor(colorTextBase, 0.02),
    colorBgContainer: getSolidColor(colorBgBase, 0),
    colorBgElevated: getSolidColor(colorBgBase, 0),
    colorBgLayout: getSolidColor(colorBgBase, 4),
    colorBgSpotlight: getAlphaColor(colorBackgroundAltInverse, 0.85),
    // Dui
    colorBgBlur: 'transparent',
    colorBorder: colorOutlineDefault,
    // Dui
    colorBorderSecondary: getSolidColor(colorBgBase, 6),
    // Dui start
    colorStatusNeutralDefault,
    colorBrandSecondaryBold,
    colorBrandSecondaryBoldest,
    colorBrandSecondarySoftest,
    colorBrandSecondarySoft,
    colorBrandSecondaryDefault
    // Dui end
  };
};